export default {
  primary: '#0d80c0',
  secondary: '#111',
  light: '#ccc',
  ultraLight: `#fff`,
  dark: '#222',
  tertiary: '#009f97',
  divider: `rgba(255,255,255,.1)`,
  background: '#111',
  background2: '#f3f4f6',
  neutral: '#252525',
  text1: '#343c5a',
  text2: '#747790',
  text3: '#9496aa',
  text4: '#afb1c0',
  hoverOpacity: 0.8
};
